import { Typography } from '@mui/material';
import styled from 'styled-components';

export const Title = styled(Typography).attrs({
  variant: 'h5',
})`
  font-weight: bold;
  line-height: 1.2;
`;
